import React, { useState } from "react";
import { useTranslation, withTranslation, Trans } from "react-i18next";
import store from "@/redux/store";
import { exportUser } from "@/reducers/User";
export function DrawerDetail({...props}) {
    let userData = props.data?.data;
    const { t, i18n, ready } = useTranslation();

    const exportUserData = (event) => {
        store.dispatch( exportUser(userData.key) );

        return false;
    }


    return (
    <>
<div className="px-4 py-6 sm:px-6 text-sm">        
    <div className="grid grid-cols-12 gap-1">
            <div className="col-span-4">
     <button
        type="button"
        className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onClick={(event) => exportUserData(event)}
      >
        Exporteer naar PDF
      </button>    
      </div>
      </div>
      </div>
<div className="px-4 py-6 sm:px-6 text-sm">
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Naam<span className="float-right">:</span></label>
            <label className="col-span-9">{userData?.fullName}</label>
        </div>
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Initialen<span className="float-right">:</span></label>
            <label className="col-span-9">{userData?.initials}</label>
        </div>
        
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Geslacht<span className="float-right">:</span></label>
            <label className="col-span-9">{t('labels.user.gender_'+userData?.gender)}</label>
        </div>
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Email adres<span className="float-right">:</span></label>
            <label className="col-span-9">{userData?.email}</label>
        </div>
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Toegevoegd op<span className="float-right">:</span></label>
            <label className="col-span-9">{userData?.created_at}</label>
        </div>
        <div className="grid grid-cols-12 gap-1">
            <label className="col-span-3">Gewijzigd op<span className="float-right">:</span></label>
            <label className="col-span-9">{userData?.updated_at}</label>
        </div>

</div>
    </>
    );
}